// Catch error on iOS version of Chrome.
if (!window.__gCrWeb) window["__gCrWeb"] = {};

import "@rails/actiontext";
import "trix";

import "jquery/src/jquery";
import "jquery-ujs";
import "bootstrap";
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js";
import "select2/dist/js/select2.full";
import "floating-scroll";
import "data-confirm-modal";

import ordinal from "ordinal";
window.ordinal = ordinal;
import Jsona from "jsona";
window.Jsona = Jsona;
import Chart from "chart.js/auto";
window.Chart = Chart;

import "./constants";
import "./broadcast";
import "./utils";
import "./initial_configs";
import "./results";
import "./intro_results";
import "./users";
import "./transition_years";
import "./student_results";
import "./charts_student";
import "./exam_summary_filter";
import "./student_targets";
import "./student_teachers";
import "./home_filter";
import "./main_table";
import "./binder";
import "./chosen_periods";
import "./shared";
import "./subject_shortcuts";
import "./subject_links";
import "./name_links";
import "./in_class_results";
import "./profile";
import "./student_uploads";
import "./student_teachers_upload";
import "./teacher_uploads";
import "./upload_results";
import "./tutor_groups";
import "./overall_tracking";
import "./general_events";
import "./subject_rankings";
import "./fitness_mark_scores";
import "./fitness_mark_student_dashboard";
import "./fitness_mark_dashboard";
